import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHeadphones: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"headphones, support"} maskId="square-filled-radius-0-stroke-1-IconHeadphones"><path d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12V13H16V21H21V12C21 7.19722 17.238 3.2731 12.5 3.01365V3H12C7.02944 3 3 7.02944 3 12V21H8V13H4V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHeadphones;
